import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigurationService } from '../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AssetsapiService {
  getHeaderSections: any;
 

  constructor(private http: HttpClient, private configService: ConfigurationService) { }
  private apiUrl = this.configService.getAPIBaseUrl(); // Base URL for your API

  GetStatementofAssetsAndLiabilities(AccpID: any): Observable<any> {
    debugger
    const url = `${this.apiUrl}/StatementofAssetsAndLiabilities/GetStatementofAssetsAndLiabilities`;
    return this.http.get<any>(url + "?PeriodID=" + AccpID);
  }
}
